import { tv, type VariantProps } from 'tailwind-variants'

export const inputVariants = tv({
  slots: {
    base: 'w-full',
    label: 'font-nunito font-bold pb-2',
    mainWrapper: 'flex flex-col group web:outline-none web:cursor-default',
    inputWrapper: [
      'py-[11px] px-4 flex flex-row',
      'border rounded-full',
      'bg-default-bg-white',
      'web:outline-none',
      'web:data-[focus-visible=true]:outline-layout-focus',
      'web:data-[focus-visible=true]:outline-4',
      'web:data-[focus-visible=true]:outline-offset-1',
    ],
    input: 'flex-1 w-full font-nunito text-md web:outline-none text-default-text-contrast-default',
    helperWrapper: 'web:grid pt-1',
    description: 'text-default-text-contrast-low text-xs',
    errorMessage: 'text-danger-text-contrast-default text-xs',
    icon: '',
    iconLeft: 'mr-0.5',
    iconRight: 'ml-0.5',
  },
  variants: {
    color: {
      default: {
        label: 'text-default-text-contrast-default',
        input: 'placeholder:text-default-text-placeholder',
        inputWrapper:
          'border-default-input-unfocus group-data-[hover=true]:border-default-input-focus group-data-[focus=true]:border-default-input-focus',
        icon: 'text-default-text-placeholder group-data-[focus=true]:text-default-text-contrast-low',
      },
      primary: {
        label: 'text-primary-text-contrast-default',
        input: 'placeholder:text-primary-text-placeholder',
        inputWrapper:
          'border-primary-input-unfocus group-data-[hover=true]:border-primary-input-focus group-data-[focus=true]:border-primary-input-focus',
        icon: 'text-primary-text-placeholder group-data-[focus=true]:text-primary-text-contrast-low',
      },
    },
    isError: {
      true: {
        label: 'text-danger-text-contrast-default',
        inputWrapper: 'border-danger-input-focus bg-default-bg-white',
      },
    },
    isInput: {
      true: { inputWrapper: 'h-12 items-center' },
      false: { inputWrapper: 'rounded-2xl' },
    },
  },
  defaultVariants: {
    color: 'default',
    isInput: true,
  },
})

export type TInputNativeSlots = keyof ReturnType<typeof inputVariants>
export type TInputVariantProps = VariantProps<typeof inputVariants>
